<template>
  <div class="vx-col">
    <div
      class="fsm-card"
      v-if="!isAuthenticated && $parent.navigationBtn"
      @click="goToHome()"
    >
      <feather-icon icon="ArrowLeftIcon" />
    </div>
    <vx-card class="vx-card-fsm justify-center items-center">
      <div slot="no-body" class="">
        <div class="p-8 vs-con-loading__container" id="loginSubmitButton">
          <div class="vx-card__title mb-8">
            <div class="flex">
              <h4 class="mb-4 w-full">
                {{ $t("PageTitle") }}
              </h4>
            </div>
            <p>
              {{ $t("Login.PersonTitle") }}
            </p>
          </div>

          <ValidationObserver
            tag="form"
            ref="loginform"
            v-bind:key="'personLoginFormKey'"
            v-on:submit.prevent
            v-slot="{ invalid }"
            v-if="!isAuthenticated && !showSmsConfirmPanel"
          >
            <div v-show="showUsernameForm">
              <ValidationProvider
                :name="$t('Login.Username')"
                rules="required|min:3"
                v-slot="{ errors }"
              >
                <vs-input
                  icon="icon icon-user"
                  icon-pack="feather"
                  :label-placeholder="$t('Login.Username')"
                  v-model="formDataLogin.Username"
                  v-on:keyup.enter="login"
                  class="w-full no-icon-border"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>

              <ValidationProvider
                :name="$t('Login.Password')"
                rules="required|min:3"
                v-slot="{ errors }"
              >
                <vs-input
                  type="password"
                  name="password"
                  icon="icon icon-lock"
                  v-on:keyup.enter="login"
                  icon-pack="feather"
                  :label-placeholder="$t('Login.Password')"
                  v-model="formDataLogin.Password"
                  ref="inputPassword"
                  class="w-full mt-6 no-icon-border"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
              <div class="flex flex-wrap justify-between my-5">
                <a href="/forgot/staff" target="_blank">{{
                  $t("Login.ForgotMyPassword")
                }}</a>
              </div>
            </div>

            <vs-button
              class="w-100 my-2 vs-con-loading__container"
              :disabled="invalid"
              @click="login()"
              >{{ $t("Login.LoginButton") }}</vs-button
            >
            <template>
              <vs-divider>{{ $t("Login.OR") }}</vs-divider>

              <div class="social-login flex flex-wrap justify-around">
                <div
                  class="
                        social-login-buttons
                        flex flex-wrap
                        justify-center
                        mt-4
                      "
                >
                  <div
                    class="
                          bg-google
                          pt-3
                          pb-2
                          px-4
                          rounded-lg
                          cursor-pointer
                          mb-4
                          w-100
                          text-center
                          text-white
                        "
                    @click="loginWithGoogle"
                  >
                    {{ $t("Login.LoginByMailPerson") }}
                  </div>

                  <div
                    class="
                          bg-turkiye
                          pt-3
                          pb-2
                          px-4
                          rounded-lg
                          cursor-pointer
                          mb-4
                          w-100
                          text-center
                          text-white
                        " 
                    @click="loginWithTurkiye"
                  > 
                    {{ $t("Login.LoginByTurkiye") }}
                  </div>
                </div>
              </div>
            </template>
          </ValidationObserver>
          <div v-if="isAuthenticated || showSmsConfirmPanel">
            <div v-if="showSmsConfirmPanel">
              <ValidationObserver
                tag="form"
                ref="loginSmsVerifyForm"
                v-on:submit.prevent
                v-slot="{ invalid }"
              >
                <div class="mb-base">
                  <span class="font-semibold" v-if="smsPhone && !smsMail"
                    >{{
                      $t("Login.SendingSms", {
                        phone: smsPhone,
                      })
                    }}
                  </span>
                  <span class="font-semibold" v-else-if="smsPhone && smsMail"
                    >{{
                      $t("Login.SendingSmsWithMail", {
                        phone: smsPhone,
                        email: smsMail,
                      })
                    }}
                  </span>
                  <span class="font-semibold" v-else-if="!smsPhone && smsMail"
                    >{{
                      $t("Login.SendingMail", {
                        email: smsMail,
                      })
                    }}
                  </span>
                </div>
                <ValidationProvider
                  :name="$t('Login.SmsCode')"
                  rules="required|length:6"
                  v-bind:key="'smsCodeInputV'"
                  v-slot="{ errors }"
                >
                  <vs-input
                    type="text"
                    v-mask="['######']"
                    icon="icon icon-lock"
                    v-on:keyup.enter="loginSmsVerify"
                    autofocus
                    icon-pack="feather"
                    :label-placeholder="$t('Login.SmsCode')"
                    v-model="loginSmsVerifyForm.SmsCode"
                    ref="loginCodeInput"
                    autocomplete="off"
                    class="w-full mt-6 no-icon-border"
                  />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
                <vs-button
                  class="
                          float-right
                          my-5
                          mb-5
                          mt-5
                          w-100
                          vs-con-loading__container
                        "
                  :disabled="invalid"
                  @click="loginSmsVerify()"
                  >{{ $t("Login.LoginSmsButton") }}</vs-button
                >
                <CountDown
                  v-if="showSmsTimer"
                  :second="smsCounter"
                  :radius="60"
                />
              </ValidationObserver>
            </div>
            <div v-else>
              <div class="mb-base" v-if="getReferal">
                <span class="font-semibold"
                  >{{ $t("Login.ReferalSite") }}:
                </span>
                <a class="font-semibold">{{ getReferal }}</a>
              </div>
              <div
                v-if="userAccounts.length && !autoLogin"
                class="p-3 bg-primary items-center justify-center"
              >
                <span class="text-sm font-semibold mb-2" style="color: white">{{
                  $t("Login.SelectAccount")
                }}</span>
              </div>
              <div
                v-show="userAccounts.length && autoLogin"
                class="p-3 bg-success items-center justify-center"
              >
                <span
                  class="text-sm font-semibold mb-2"
                  style="color: white; font-size:0.78rem!important;"
                >
                  <div
                    class="vs-con-loading__container loading-example"
                    id="login-loader"
                  >
                    <div class="vs-loading material">
                      <svg
                        width="16px"
                        height="16px"
                        viewBox="0 0 66 66"
                        xmlns="http://www.w3.org/2000/svg"
                        class="spinner"
                      >
                        <circle
                          fill="none"
                          stroke-width="5"
                          stroke-linecap="round"
                          cx="33"
                          cy="33"
                          r="30"
                          class="path"
                        ></circle>
                      </svg>
                    </div>
                  </div>
                  {{ $t("Login.RedirectWebSite") }}</span
                >
              </div>
              <div id="email-app">
                <transition-group
                  name="list-enter-up"
                  class="email__mails"
                  tag="ul"
                  appear
                >
                  <li
                    class="cursor-pointer email__mail-item"
                    v-for="(user, index) in userAccounts"
                    :key="'useracc_' + index"
                    :style="{ transitionDelay: index * 0.1 + 's' }"
                    @click="goWebSite(user)"
                  >
                    <div class="mail__mail-item sm:px-4 px-2 py-6">
                      <div class="flex w-full">
                        <vs-avatar
                          class="
                                sender__avatar
                                flex-shrink-0
                                mr-3
                                border-2 border-solid border-white
                              "
                          :src="user.Picture"
                          size="40px"
                        ></vs-avatar>

                        <div class="flex w-full justify-between items-center">
                          <div class="mail__details">
                            <h5 class="mb-1 font-semibold">
                              {{ user.FullName }}
                            </h5>
                            <span>{{ user.Email }}</span>
                          </div>

                          <div
                            class="
                                  mail-item__meta
                                  flex
                                  items-center
                                  justify-center
                                "
                          >
                            <feather-icon
                              icon="LogInIcon"
                              :svgClasses="['h-10 w-10 text-success']"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li
                    class="cursor-pointer email__mail-item"
                    key="useracc_logout"
                    @click="logout()"
                    :style="{
                      transitionDelay: userAccounts.length * 0.1 + 's',
                    }"
                  >
                    <div class="mail__mail-item sm:px-4 px-2 py-6">
                      <div class="flex w-full">
                        <div
                          class="
                                mail-item__meta
                                flex
                                items-center
                                justify-center
                                pl-2
                              "
                        >
                          <feather-icon
                            icon="LogOutIcon"
                            :svgClasses="['h-10 w-10 text-danger']"
                            :style="{ transform: 'rotateZ(180deg)' }"
                          />
                          <h5 class="ml-4 font-semibold">
                            {{ $t("User.Logout") }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </li>
                </transition-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Vue from "vue";
import AuthApi from "@/api/auth";
import CountDown from "@/components/countdown";
var checkSmsCounter = null;

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    CountDown,
  },
  data() {
    return {
      localProfile: {},
      autoLogin: false,
      showUsernameForm: true,
      radios1: 1,
      KVKK: true,
      formDataLogin: {
        Username: "",
        Password: "",
        RememberMe: true,
        GoogleReCaptchaResponse: "",
        Referer: "",
        ReturnUrl: "",
        Tumer: false,
      },
      formDataLoginOther: {
        IdentityNumber: "",
        PhoneNumber: "",
        BirthDate: "",
        Gender: 0,
        Referer: "",
      },
      userAccounts: [],
      submitBusy: false,
      returnUrl: "",
      showSmsConfirmPanel: false,
      smsExpiryDate: null,
      smsCounter: 0,
      smsUserId: null,
      smsPhone: null,
      smsMail: null,
      dateNow: null,
      loginSmsVerifyForm: {
        Token: null,
        SmsCode: null,
      },
    };
  },
  computed: {
    showSmsTimer() {
      this.dateNow;
      return this.smsExpiryDate && new Date(this.smsExpiryDate) >= new Date();
    },
    getReferal() {
      this.returnUrl;
      var url = this.$route.query.ReturnUrl || this.returnUrl;
      if (url) {
        let link = new URL(url);
        if (link && link.host) return link.host;
      }
      return "";
    },
    getReferalFullPath() {
      this.returnUrl;
      var url = this.$route.query.ReturnUrl || this.returnUrl;
      if (url) {
        let link = new URL(url);
        if (link && link.host) return link.href;
      }
      return "";
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    isAuthenticated() {
      this.localProfile;
      this.showSmsConfirmPanel;
      return this.$auth.isAuthenticated();
    },
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale == "tr") return { flag: "tr", lang: "Türkçe" };
      else if (locale == "en") return { flag: "en", lang: "English" };
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },
  },
  beforeDestroy() {
    clearInterval(checkSmsCounter);
  },
  async created() {
    if (this.$route.params.project) {
      var projectName = this.$route.params.project.replace(/[^a-zA-Z]/g, "");
      if (projectName) {
        var findUrl = await AuthApi.findReferralUrl(
          {
            ProjectName: projectName,
          },
          this
        );

        if (!findUrl.data.error && !findUrl.data.errors) {
          this.$route.query.ReturnUrl = findUrl.data.returnUrl;
          this.returnUrl = findUrl.data.returnUrl;
        }
      }
    }

    if (this.$auth.isAuthenticated()) {
      this.$vs.loading({
        color: "#000",
        scale: 0.45,
      });

      var users = await AuthApi.getMyUsers(
        {
          Referer: this.$route.query.ReturnUrl,
        },
        this
      );

      if (!users.data.error && !users.data.errors) {
        this.userAccounts = users.data.Users;
        if (this.userAccounts && this.userAccounts.length == 1)
          await this.goWebSite(this.userAccounts[0]);
      } else this.$auth.logOut();

      setTimeout(() => {
        this.$vs.loading.close(".con-vs-loading");
      }, 100);
    }
  },
  methods: {
    async loginSmsVerify() {
      const isValid = await this.$refs.loginSmsVerifyForm.validate();
      if (this.submitBusy || !isValid) return;
      this.submitBusy = true;
      this.$vs.loading({
        color: "#000",
        container: "#loginSubmitButton",
        scale: 0.45,
      });

      try {
        this.loginSmsVerifyForm.Token = this.smsUserId;
        let response = await AuthApi.loginSmsVerify(
          this.loginSmsVerifyForm,
          this
        );

        setTimeout(() => {
          this.$vs.loading.close(".con-vs-loading");
        }, 100);

        if (!response.data.error) {
          this.$auth.twoFactComplete();
          this.showSmsConfirmPanel = false;
          this.smsExpiryDate = null;
          this.smsUserId = null;
          this.smsPhone = null;
          this.smsMail = null;
          this.$auth.setToken(response.data);

          this.$store.dispatch("auth/updateLoginGroup", "staff");

          this.$vs.loading({
            color: "#000",
            scale: 0.45,
          });

          var users = await AuthApi.getMyUsers(
            {
              Referer: this.$route.query.ReturnUrl,
            },
            this
          );

          if (!users.data.error && !users.data.errors) {
            this.userAccounts = users.data.Users;
            if (this.userAccounts && this.userAccounts.length == 1)
              await this.goWebSite(this.userAccounts[0]);
          } else this.$auth.logOut();

          setTimeout(() => {
            this.$vs.loading.close(".con-vs-loading");
          }, 100);
        }
      } finally {
        this.submitBusy = false;
      }
    },
    goToHome() {
      this.$parent.setForm("");
    },
    async goWebSite(user) {
      if (this.autoLogin) return;
      if (user) {
        this.autoLogin = true;

        setTimeout(async () => {
          if (this.autoLogin && user.GatewayUrl) {
            try {
              if (user.ModuleType == 0) {
                let gateway = await AuthApi.gateway(user.GatewayUrl, this);
                if (gateway.data.success && this.getReferalFullPath)
                  window.location.assign(this.getReferalFullPath);
              } else if (user.ModuleType == 1) {
                window.location.assign(user.GatewayUrl);
              } else if (user.ModuleType == 4) {
                // Cross-domain SPA (CMS admin.fatihsultan.edu.tr): gateway token
                // URL'sini TAM SAYFA ac. XHR + ucuncu-taraf cookie modeli
                // (ModuleType 0) farkli kok domainde calismaz; first-party sart.
                // Hedef: {host}/api/gateway/login?token=...
                window.location.assign(user.GatewayUrl);
              } else if (user.ModuleType == -1) {
                window.location.assign(this.getReferalFullPath);
              }
            } catch {}
            this.autoLogin = false;
          } else if (this.autoLogin && !user.GatewayUrl) {
            this.$auth.hideLogin(user);
            this.$router.push("/");
          }
        }, 2000);
      }
    },
    updateLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
    },
    logout() {
      this.$auth.logOut();
      this.userAccounts = [];
      this.autoLogin = false;
    },
    loginWithGoogle() {
      this.$parent.setForm("staff");

      window.location.assign(
        process.env.VUE_APP_BASE_URL +
          "api/auth/google?returnUrl=" +
          (this.$route.query.ReturnUrl
            ? process.env.VUE_APP_BASE_URL +
              "login?ReturnUrl=" +
              this.$route.query.ReturnUrl
            : process.env.VUE_APP_BASE_URL)
      );
    },
    loginWithTurkiye() {
      this.$parent.setForm("staff");

      window.location.assign(
        process.env.VUE_APP_BASE_URL +
          "api/auth/edevlet?returnUrl=" +
          (this.$route.query.ReturnUrl
            ? process.env.VUE_APP_BASE_URL +
              "login?ReturnUrl=" +
              this.$route.query.ReturnUrl
            : process.env.VUE_APP_BASE_URL)
      );
    },
    async login() {
      const isValid = await this.$refs.loginform.validate();
      if (this.submitBusy || !isValid) return;

      this.submitBusy = true;
      this.$vs.loading({
        color: "#000",
        container: "#loginSubmitButton",
        scale: 0.45,
      });
      try {
        this.formDataLogin.Referer = this.$route.query.ReturnUrl;
        this.$recaptcha("login").then(async (token) => {
          this.formDataLogin.GoogleReCaptchaResponse = token;
          await this.$auth.loginForPerson(this.formDataLogin, this);
        });
      } finally {
        this.submitBusy = false;
      }
    },
    async handleLoginEvent(payload) {
      this.autoLogin = false;
      this.localProfile = payload;
      setTimeout(() => {
        this.$vs.loading.close("#loginSubmitButton .con-vs-loading");
      }, 100);

      if (payload.loggedIn) {
        this.showSmsConfirmPanel = true;
        this.smsPhone = payload.Phone;
        this.smsUserId = payload.Token;
        this.smsExpiryDate = payload.SmsCodeValidTime;
        this.smsCounter = payload.TotalSecond;
        this.dateNow = new Date();

        checkSmsCounter = setInterval(() => {
          this.dateNow = new Date();
          if (!this.showSmsTimer) {
            clearInterval(checkSmsCounter);
            this.loginSmsVerifyForm = {
              Token: null,
              SmsCode: "",
            };

            this.showSmsConfirmPanel = false;
            this.smsExpiryDate = null;
            this.smsUserId = null;
            this.smsPhone = null;
            this.formDataLogin.Password = "";
          }
        }, 1000);
      } else this.$store.dispatch("auth/updateLoginGroup", "");
    },
  },
};
</script>

<style lang="scss">
.p-120 {
  padding-top: 120px !important;
  margin-bottom: 100px !important;
}

.light-shadow {
  .vx-card:hover {
    box-shadow: unset !important;
  }
}
</style>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";

#login-loader {
  width: 16px;
  height: 16px;
  float: left;
  margin-right: 5px;
}
.vx-card-fsm {
  max-width: 423px;
  width: 100vh;
}

@media (max-width: 450px) {
  .vx-card-fsm {
    width: 100% !important;
  }
}
</style>
